import React, { FunctionComponent } from 'react';

import DatePicker from '../DatePicker';

type Props = DrainDownStepProps &
  Pick<DrainDownForm, 'reconnectionSlotId'> & {
    availableSlots?: DrainDownSlot[];
  };

const ReconnectionDate: FunctionComponent<Props> = ({
  onStepChange,
  onFormChange,
  reconnectionSlotId,
  availableSlots,
}) => {
  return (
    <DatePicker
      title="Select Dates for Reconnection"
      onProceed={onStepChange}
      onFormChange={onFormChange}
      name="reconnection"
      value={reconnectionSlotId}
      buttonText="Submit"
      availableSlots={availableSlots}
    />
  );
};

export default ReconnectionDate;
